"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const IssueIcon_1 = __importDefault(require("@opsbase/web-icons/icons/IssueIcon"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importDefault(require("react"));
function QuestionEditorIssueButton(props) {
    const { enable, isLabel, onClick, disabled } = props;
    return (react_1.default.createElement(Tooltip_1.default, { arrow: true, transparent: false, placement: 'bottom', tip: react_1.default.createElement("div", { style: { padding: 5 } },
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('add-issue-question'))) },
        react_1.default.createElement(Button_1.default, { round: true, disabled: disabled || !isLabel, icon: react_1.default.createElement(IssueIcon_1.default, { size: 22, color: enable ? lib_palette_1.default.error : lib_palette_1.default.LavendarGrey }), color: enable && isLabel ? lib_palette_1.default.BackgroundGrey : lib_palette_1.default.White, onClick: onClick })));
}
exports.default = QuestionEditorIssueButton;
